import React, { useState } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import ArrowDropUpIcon from "@mui/icons-material/ArrowDropUp";
import ArrowDropDownIcon from "@mui/icons-material/ArrowDropDown";
import { KeyboardArrowLeft, KeyboardArrowRight } from "@mui/icons-material";
import { useTranslation } from "react-i18next";


export interface IYearMonthStepperProps {
    month: number;
    year: number;
    setYear: React.Dispatch<React.SetStateAction<number>>
    setMonth: React.Dispatch<React.SetStateAction<number>>
}

const YearMonthStepper = (props: IYearMonthStepperProps) => {
    const { month, year, setYear, setMonth } = props;
    const { t } = useTranslation();

    const moveBackward = () => {
        if (month === 1) {
            setMonth(12);
            setYear((prevYear) => prevYear - 1);
        } else {
            setMonth((prevMonth) => prevMonth - 1);
        }
    };

    const moveForward = () => {
        if (month === 12) {
            setMonth(1);
            setYear((prevYear) => prevYear + 1);
        } else {
            setMonth((prevMonth) => prevMonth + 1);
        }
    };

    const months = [
        t("calendar.january"),
        t("calendar.february"),
        t("calendar.march"),
        t("calendar.april"),
        t("calendar.may"),
        t("calendar.june"),
        t("calendar.july"),
        t("calendar.august"),
        t("calendar.september"),
        t("calendar.october"),
        t("calendar.november"),
        t("calendar.december")
    ];

    return (
        <Box display="flex" flexDirection="column" alignItems="center" sx={{
            /* position: "fixed", bottom: 0, zIndex: 1,
            left: "50%",
            transform: "translateX(-50%)" */
            marginLeft: "auto",
            marginRight: "auto",
            marginTop: "auto",
            paddingTop: '8px'
        }}>
            <Box display="flex" alignItems="center" marginBottom={2} bgcolor={"#FFC600"} padding={2}>
                <IconButton size="small" onClick={moveBackward}>
                    <KeyboardArrowLeft />
                </IconButton>
                <Typography variant="h6">
                    {months[month - 1]} {year}
                </Typography>
                <IconButton size="small" onClick={moveForward} >
                    <KeyboardArrowRight />
                </IconButton>
            </Box>
        </Box>
    );
};

export default YearMonthStepper;
